import { createComponent } from '@carvana/merch-components';

export const Buttons = createComponent('div', {
  className:
    'flex flex-col gap-lg [&>:nth-child(1)]:grow md:[&>:nth-child(1)]:w-[260px] md:[&>:nth-child(2)]:w-[calc((100%+260px)/2)]'
});

export const ButtonContainer = createComponent('a', {
  className:
    'flex cursor-pointer items-center justify-between gap-xl self-stretch rounded-lg border border-solid border-border-subtle bg-background-weak p-xl hover:border-border-primary'
});

export const Copy = createComponent('div', {
  className: 'flex grow flex-col'
});

export const CopyHeading = createComponent('h2', {
  className: 'text-text-strong t-label-md'
});

export const CopyDescription = createComponent('p', {
  className: 'text-text-default t-body-sm'
});

export const Shop = createComponent('span', {
  className: 'self-center text-text-primary t-label-sm'
});
